import { Injectable } from '@angular/core';
import { PromiseUtilsService } from 'src/app/shared/services/promise-utils.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WebPageUrlValidationService {
  constructor(
    private promiseUtils: PromiseUtilsService,
    private httpClient: HttpClient,
  ) {}

  validate(url, authenticatedWebPage = false) {
    if (!url || authenticatedWebPage) {
      return Promise.resolve('VALID');
    }

    let value = url;

    // Add https:// if no protocol parameter exists
    if (value.indexOf('://') === -1 || value.indexOf('://') > 5) {
      value = 'https://' + value;
    }

    var deferred = this.promiseUtils.generateDeferredPromise();

    this.httpClient
      .get(environment.PROXY_URL + value, {
        responseType: 'text',
        observe: 'response',
      })
      .toPromise()
      .then(
        (response: any) => {
          if (isSameDestinationRedirect(response?.headers)) {
            return deferred.resolve('REDIRECT_BLOCKED');
          }

          const allowedDomains = ['*.risevision.com', 'widgets.risevision.com'];
          let restricted = false;
          let header;

          header = response.headers.get('X-Frame-Options');
          if (header) {
            restricted = true;
          }

          header = response.headers.get('content-security-policy');
          if (header && header.includes('frame-ancestors')) {
            restricted = !allowedDomains.some((domain) =>
              header.includes(domain),
            );
          }

          if (restricted) {
            return deferred.resolve('FRAME_RESTRICTED');
          }

          return deferred.resolve('VALID');
        },
        (error) => {
          if (isSameDestinationRedirect(error?.headers)) {
            return deferred.resolve('REDIRECT_BLOCKED');
          }
          return deferred.resolve('LOAD_FAILURE');
        },
      )
      .catch((err) => {
        deferred.reject(err);
      });

    return deferred.promise;
  }
}

function isSameDestinationRedirect(headers?: {
  get?: (name: string) => string | null;
}): boolean {
  const value = headers?.get?.('X-Rise-Redirect-Same-Destination');
  return String(value).toLowerCase() === 'true';
}
